import { Add } from '@mui/icons-material';
import { Chip, Grid, Stack } from '@mui/material';
import React, { ReactNode } from 'react';
import { StyledTextField } from './StyledTextField';

interface ListFormProps {
  items: string[];
  onChange(items: string[]): void;
  label?: string;
  forbiddenCharacters?: string[];
  inputTooltip?: ReactNode;
  inputHint?: string;
}

interface ListFormState {
  stagedItem: string;
  currentItems: string[];
}

export class ListForm extends React.Component<ListFormProps, ListFormState> {
  public state: ListFormState = {
    currentItems: [],
    stagedItem: '',
  };

  public static getDerivedStateFromProps(
    props: Readonly<ListFormProps>,
    state: ListFormState,
  ): Partial<ListFormState> | null {
    const { items } = props;
    const { currentItems } = state;

    const isEqual = items.length === currentItems.length && items.every((v, i) => v === currentItems[i]);

    if (!isEqual) {
      return { currentItems: items };
    }

    return null;
  }

  public addItem = (): void => {
    const { onChange } = this.props;
    const { stagedItem, currentItems } = this.state;

    currentItems.push(stagedItem);
    const newItems = [...new Set(currentItems)]; // ensure no duplicate

    this.setState({ currentItems: newItems, stagedItem: '' }, () => onChange(newItems));
  };

  public removeItem = (index: number): void => {
    const { onChange } = this.props;
    const { currentItems } = this.state;

    currentItems.splice(index, 1);

    this.setState({ currentItems: currentItems.slice() }, () => onChange(currentItems));
  };

  public render(): React.JSX.Element {
    const { label, forbiddenCharacters, inputTooltip, inputHint } = this.props;
    const { currentItems, stagedItem } = this.state;

    const isForbidden = forbiddenCharacters?.some((fc) => stagedItem.includes(fc));

    return (
      <Stack spacing={1} justifyContent={'flex-start'}>
        <StyledTextField
          type={'text'}
          label={label ?? 'Add Item'}
          value={stagedItem}
          onChange={(e) => this.setState({ stagedItem: e.target.value as string })}
          action={{
            onClick: () => this.addItem(),
            icon: Add,
            disabled: stagedItem === '' || isForbidden,
          }}
          tooltip={inputTooltip}
          helperText={inputHint}
        />
        <Grid container spacing={1}>
          {currentItems.map((item: string, index: number) => (
            <Grid item xs={'auto'} key={`list-form-item-${index}`}>
              <Chip label={item} onDelete={() => this.removeItem(index)} />
            </Grid>
          ))}
        </Grid>
      </Stack>
    );
  }
}
